import http from "../http-common";
import { ICardEventAdmin, ICardEventAdminPost } from "../../models/component/ICardEventAdmin";
import { IGallery } from "../../models/component/IGallery";

const addImages = (images: FileList, token: string) => {
  const formData = new FormData();
  for (let i = 0; i < images.length; i++) {
    formData.append('images', images[i]);
  }
  return http.post<any>("/gallery", formData, {
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "multipart/form-data"
    }
  });
};

const getAll = () => {
  return http.get<IGallery>("/gallery");
};

const remove = (id: number,token:string) => {
  return http.delete<any>(`/images/${id}`, { headers: { Authorization: "Bearer " + token } });
};

const GalleryService = {
  getAll,
  addImages,
  remove
};

export default GalleryService;